"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../styles/WhatYourNeedComponent.css");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
const WhatYourNeedComponent = _ref => {
  let {
    whatYourNeedContentArray,
    modalHeaderText,
    modalTopContent
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "what-your-need-modal-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "what-your-need-modal-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: modalHeaderText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "what-your-need-modal-top-content"
  }, modalTopContent), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "You'll add your system"), /*#__PURE__*/_react.default.createElement("li", null, "You'll choose your accessory (or accessories) if needed"), /*#__PURE__*/_react.default.createElement("li", null, "You'll choose your filter"), /*#__PURE__*/_react.default.createElement("li", null, "Tell us the water destination"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#333333',
      fontSize: '16px',
      fontWeight: '600'
    }
  }, "System Added"), ' ', "You'll see your system on this dashboard"))));
};
var _default = exports.default = WhatYourNeedComponent;